__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/0c2588ba4be71b5a02bfe494f3e2570dc2fd8b18/_next/";